import styled from "@emotion/styled"

export default styled.h2`
  font-size: 2.133rem;
  font-weight: 100;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${props => props.theme.colors.primary};
`
